import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

import DotsIcon from "../../icons/dots1.svg";
import BoutIcon from "../../icons/bout.svg";

function CommonGroundReason(props) {

	const { setNodeRef, setActivatorNodeRef, attributes, listeners, transform, transition } = useSortable({ id: props.commonGround.id });
  const sortableStyle = { transform: CSS.Transform.toString(transform), transition };

	const style = {
		reason: {
			item: "relative m-1 px-5 pt-5 pb-2 border-1 border-gray-800 rounded-md"
		},
		icon: {
			moveButton: "w-[22px] absolute top-1 left-1 cursor-grab",
			boutButton: "w-[24px] absolute top-1 right-1 p-0.5 border border-black/50 rounded-md hover:bg-slate-300 cursor-pointer",
		}
	}

	function openConfirmationModal(type) {
		const action = {
			type: type,
			data: {
				...props.commonGround
			}
		}
		props.openConfirmActionModal(action);
	}

	return (
		<li ref={setNodeRef} style={sortableStyle} {...attributes} className={style.reason.item}>
			{props.role === "referee" ?
				(
					<>
						<button
							ref={setActivatorNodeRef}
							{...listeners}
							aria-label="Move Button"
							className={style.icon.moveButton}>
							<DotsIcon />
						</button>
						<button
							aria-label="Begin Bout"
							className={style.icon.boutButton}
							onClick={() => openConfirmationModal('moveCG-Rip')}>
							<BoutIcon />
						</button>
					</>
				)
			: null}
			<div>{props.commonGround.reason}</div>
		</li>
	)
}

export default CommonGroundReason;
